import { format, parse } from 'date-fns';

/** Shared trigger classes for calendar/select triggers with consistent shadow-none styling. */
export const FIELD_TRIGGER_CLASSES =
  'w-full justify-start text-left font-normal border border-input bg-transparent shadow-none hover:shadow-none hover:bg-transparent';

/** Generate time options in 15-minute increments for the select dropdown. */
function generateTimeOptions(): string[] {
  const options: string[] = [];
  for (let h = 6; h <= 20; h++) {
    for (let m = 0; m < 60; m += 15) {
      const hour12 = h % 12 || 12;
      const ampm = h < 12 ? 'AM' : 'PM';
      const minutes = m.toString().padStart(2, '0');
      options.push(`${hour12}:${minutes} ${ampm}`);
    }
  }
  return options;
}

export const TIME_OPTIONS = generateTimeOptions();

const TIME_PARSE_FORMATS = ['h:mm a', 'hh:mm a', 'h:mma', 'hh:mma', 'H:mm', 'HH:mm'];

/** Normalize an AI-returned time string into the `h:mm AM` format used by TIME_OPTIONS. */
export function normalizeTime(raw: string): string {
  if (!raw) return raw;
  const trimmed = raw.trim();
  for (const fmt of TIME_PARSE_FORMATS) {
    try {
      const d = parse(trimmed, fmt, new Date());
      if (!isNaN(d.getTime())) return format(d, 'h:mm a');
    } catch { /* try next format */ }
  }
  return trimmed;
}

/** Parse a MM/DD/YYYY date string to a Date object. */
export function parseDateString(dateStr: string): Date | undefined {
  if (!dateStr) return undefined;
  try {
    const d = parse(dateStr, 'MM/dd/yyyy', new Date());
    return isNaN(d.getTime()) ? undefined : d;
  } catch {
    return undefined;
  }
}
